module.exports = __webpack_public_path__ + "img/DK15416718.2f9e3b74.png";